import axios from "axios";
import { BASE_URL } from '../../Utils/base_url';

const AjouteInformation = async (data) => {
    return await axios.post(`${BASE_URL}/api/restaurant/ajouteInformation`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
        }
    });
}
const AfficheInformation = async (idRestaurant) => {
    return await axios.get(`${BASE_URL}/api/restaurant/afficheInformation/${idRestaurant}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
        }
    });
}
const AfficheConger = async (idRestaurant) => {
    return await axios.get(`${BASE_URL}/api/restaurant/afficheFermetureConger/${idRestaurant}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
        }
    });
}



export { AjouteInformation, AfficheInformation, AfficheConger }